"use client";

import { BlurFade } from "@/components/ui/blur-fade";

interface Stat {
  value: string;
  label: string;
  description?: string;
}

interface StatsBarProps {
  stats: Stat[];
}

const StatsBar = ({ stats }: StatsBarProps) => {
  if (!stats || stats.length === 0) return null;

  return (
    <section className="py-16 px-6 bg-foreground">
      <div className="container max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4">
          {stats.map((stat, i) => (
            <BlurFade key={i} delay={0.1 + i * 0.08}>
              <div className="flex flex-col items-center text-center gap-2">
                <span className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight">
                  {stat.value}
                </span>
                <span className="text-sm md:text-base font-semibold text-white/70 uppercase tracking-wider">
                  {stat.label}
                </span>
                {stat.description && (
                  <span className="text-xs text-white/40 max-w-[200px] leading-relaxed">
                    {stat.description}
                  </span>
                )}
              </div>
            </BlurFade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
